<template>
  <v-container>
    <v-card>
      <v-card-text>
        <DeliverySlipGrid :loading="loading" history></DeliverySlipGrid>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { DeliverySlipGrid } from "../components";
export default {
  name: "DeliverySlipHistory",
  components: {
    DeliverySlipGrid
  },
  computed: {
    ...mapGetters(["getIsAdmin"])
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getData();
    });
  },
  async beforeRouteUpdate() {
    await this.getData();
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        Promise.all([
          this.$store.dispatch("loadInventoryRecords", {
            store: this.getStoreId,
            latest: true
          }),
          this.$store.dispatch("loadOrderTemplates"),
          this.$store.dispatch("loadProducts"),
          this.$store.dispatch("loadSuppliers")
        ]);
        await this.$store.dispatch("loadDeliverySlips");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
